"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UserAvatar = _interopRequireDefault(require("../style/UserAvatar.scss"));

var _AppContext = _interopRequireDefault(require("../context/AppContext"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Renders user avatar if a valid `user.src` is provided.
 * Otherwise, renders the default avatar.
 * @reactProps {string} className - css class names to add to the rendered elements.
 * @reactProps {string} user - the user object.
 * @return {ReactElement} user avatar markup.
 */
var UserAvatar = /*#__PURE__*/_react.default.memo(function (_ref) {
  var className = _ref.className,
      user = _ref.user;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var _useContext = (0, _react.useContext)(_AppContext.default),
      environment = _useContext.environment;

  var avatarEndpoint = environment === 'stage' ? _constants.AVATAR_PREFIX_STAGE : _constants.AVATAR_PREFIX_PROD;
  var onError = (0, _react.useCallback)(function () {
    setError(true);
  }, [setError]);
  var userAvatarClassNames = (0, _classnames.default)(_UserAvatar.default.avatar, className);
  var isGuest = user && (!user.email || user.email === 'None');
  var userAvatarSrc; // Generate the user image URL based on the identity endpoint and ID if not available

  if (user && !isGuest) {
    if (user.src) {
      userAvatarSrc = user.src;
    } else if (user.id) {
      userAvatarSrc = "".concat(avatarEndpoint).concat(user.id.replace(_constants.USER_ID_PREFIX, ''));
    }
  } // It is expected that guest avatars will return an error, since they don't have a profile.  Show the SVG in that case.


  return userAvatarSrc && !error ? /*#__PURE__*/_react.default.createElement("img", {
    "aria-hidden": "true",
    "data-testid": "ccx-comments-user-avatar",
    className: userAvatarClassNames,
    src: userAvatarSrc,
    onError: onError
  }) : /*#__PURE__*/_react.default.createElement("svg", {
    "aria-hidden": "true",
    className: "".concat(userAvatarClassNames, " placeholder"),
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    width: "24",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    "data-testid": "ccx-comments-default-avatar"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "50",
    height: "50"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33,33.2c-4.3-0.3-4.6-4-4-5.2c0.6-1.2,0.7-3.1,0.7-3.1s1,0.2,1.3-2.2s-1-1.8-1-1.8s0.7-2.8,0.2-5.8 c-0.1-0.8-1.1-1.5-1.9-2.1c-0.9-0.7-1.4-1.8-2.5-1.8c-1.6,0-6.1,2.3-6.4,3.9c-0.7,3,0.6,5.7,0.6,5.7s-1.3-0.6-1,1.8 s1.3,2.2,1.3,2.2s0.1,1.9,0.7,3.1c0.6,1.2,0.6,5-3.7,5.4S9,35.7,9,35.7v3.1h16h16v-3.1C41,35.7,37.3,33.5,33,33.2z"
  }));
});

UserAvatar.displayName = 'UserAvatar';
UserAvatar.propTypes = {
  className: _propTypes.default.string,
  user: _propTypes.default.object
};
var _default = UserAvatar;
exports.default = _default;